// Analytics disabled when self-hosting: the upstream project hardcoded the
// original author's Google Analytics tracking ID, which would send our
// visitors' pageviews to a third party. Kept as a no-op to preserve the
// component's interface used in App.js.
function GoogleAnalytics() {
  return null;
}

export default GoogleAnalytics;
